import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Error boundary for React errors
class ErrorBoundary extends React.Component<
  {children: React.ReactNode},
  {hasError: boolean; error?: Error}
> {
  constructor(props: {children: React.ReactNode}) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Dashboard Error:', error, errorInfo)
    
    // In production, you might want to log to an error service
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
      // Send error to monitoring service
      fetch('/api/errors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          error: error.message,
          stack: error.stack,
          errorInfo,
          timestamp: new Date().toISOString(),
          url: window.location.href,
          userAgent: navigator.userAgent
        })
      }).catch(e => console.error('Failed to log error:', e))
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          background: '#0a0a0a',
          color: '#fff',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1 style={{ marginBottom: '20px', color: '#ff4757' }}>
            Dashboard Error
          </h1>
          <p style={{ marginBottom: '20px', maxWidth: '600px', color: '#888' }}>
            Something went wrong with the Alpha Discovery Dashboard. 
            Please refresh the page or contact support if the problem persists.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              background: '#00d4aa',
              color: '#000',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Refresh Page
          </button>
          
          {true && (
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', color: '#00d4aa' }}>
                Error Details (Development)
              </summary>
              <pre style={{ 
                marginTop: '10px', 
                padding: '20px', 
                background: '#1a1a1a', 
                borderRadius: '6px',
                fontSize: '12px',
                overflow: 'auto',
                maxWidth: '100%'
              }}>
                {this.state.error?.stack || this.state.error?.message}
              </pre>
            </details>
          )}
        </div>
      )
    }

    return this.props.children
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)